import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import AdminDashboard from '../components/AdminDashboard';
import EnhancedAdminDashboard from '../components/EnhancedAdminDashboard';
import LoginPage from '../components/login-page';
import { AdminThemeProvider, useAdminTheme } from '../contexts/AdminThemeContext';
import Icon from '../components/AppIcon';

const AdminContent = () => {
  const { currentColors, isDarkMode, toggleTheme } = useAdminTheme();
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const handleLogin = (success) => {
    if (success) {
      setIsAuthenticated(true);
    }
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem('adminAuthenticated');
  };

  // Check if already authenticated on component mount
  React.useEffect(() => {
    const authStatus = localStorage.getItem('adminAuthenticated');
    if (authStatus === 'true') {
      setIsAuthenticated(true);
    }
  }, []);

  if (isAuthenticated) {
    return (
      <>
        <Helmet>
          <title>Admin Dashboard | Bootminds Elite</title>
          <meta name="description" content="Admin Dashboard for Bootminds Elite" />
        </Helmet>
        <EnhancedAdminDashboard onLogout={handleLogout} />
      </>
    );
  }

  return (
    <div className="relative">
      {/* Theme Toggle */}
      <button
        onClick={toggleTheme}
        className="absolute top-6 right-6 p-3 rounded-xl transition-all duration-300 hover:scale-110 z-50"
        style={{ 
          backgroundColor: `${currentColors.primary}20`,
          color: currentColors.primary,
          backdropFilter: 'blur(10px)'
        }}
        aria-label={`Switch to ${isDarkMode ? 'light' : 'dark'} mode`}
      >
        <Icon 
          name={isDarkMode ? "Sun" : "Moon"} 
          size={20} 
          className="text-current"
        />
      </button>

      {/* Use the new LoginPage component */}
      <LoginPage onLogin={handleLogin} />
    </div>
  );
};

// Wrapper component that provides theme context
const Admin = () => {
  return (
    <AdminThemeProvider>
      <AdminContent />
    </AdminThemeProvider>
  );
};

export default Admin;
